import { localizeParam, matchParam } from '$lib/i18n-url';

const localizedParam = localizeParam(2, 'l_imprint', {
	en: 'imprint',
	de: 'impressum'
});

export const match = (param) => matchParam(param, localizedParam);
